import Box from 'components/shared/Box'
import Text from 'components/shared/Text'
import routeDots from 'assets/images/decors/routeDots.svg'
import smallRouteDots from 'assets/images/decors/routeDotsSmall.svg'
import { Color, TextVariant } from 'styles/types'

interface RouteTitleProps {
    from: string
    to: string
    variant?: TextVariant
    color?: Color
    hasSmallDots?: boolean
}

const RouteTitle = ({
    from,
    to,
    variant = 'heading4',
    color = 'grayscale_900',
    hasSmallDots = false,
}: RouteTitleProps) => (
    <Box direction="row" gap={8} align="center">
        <Text as="span" variant={variant} color={color}>
            {from}
        </Text>
        <img src={hasSmallDots ? smallRouteDots : routeDots} alt="dots" />
        <Text as="span" variant={variant} color={color}>
            {to}
        </Text>
    </Box>
)

export default RouteTitle
